// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608130134/js/" + chunkId + "." + {"44":"a4a940d5","225":"b65f3e5b","481":"4465c4bd","486":"24628d84","770":"66f1045d"}[chunkId] + ".0.3444273575906921.chunk.js";
};